import React from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import { FaBed } from "react-icons/fa";

const BedStatus = ({ setIsModalOpen }) => {
  const statuses = [
    { text: "Occupied", color: "text-green-500" },
    { text: "Entire Room Occupied", color: "text-purple-500" },
    { text: "Vacant", color: "text-gray-500" },
    { text: "Vacant & Reserved", color: "text-teal-500" },
    { text: "Entire Flat Occupied", color: "text-yellow-500" },
    { text: "Moving out", color: "text-red-500" },
    { text: "Moving out & Reserved", color: "text-blue-500" },
  ];

  return (
    <Model width="w-11/12 max-w-md" setOpenModel={setIsModalOpen}>
      <Wrapper>
        <StatusList>
          {statuses.map((status, index) => (
            <StatusItem key={index}>
              <Icon className={status.color} />
              <span>{status.text}</span>
            </StatusItem>
          ))}
        </StatusList>

      </Wrapper>
    </Model>
  );
};


const Wrapper = tw.div`px-4`;
const StatusList = tw.ul`flex flex-col gap-3`;
const StatusItem = tw.li`flex items-center gap-2 py-2 border-b border-gray-200 last:border-none cursor-pointer`;
const Icon = tw(FaBed)`text-lg`;

export default BedStatus;
